import StewardAssetDisplayPage from './StewardAssetDisplayPage';

export default StewardAssetDisplayPage;
